import { get } from 'lodash';
import React from 'react';
import { getLocalstorageToken } from 'src/context/AuthHelper';
import { ANTRAG_TYP, KOSTEN_ARTEN } from 'src/lib/constants/constant';
import { getKostenHinweisStruc } from 'src/utils/ausgabenFinanzierungHelper';
import SachkostenSkizzeEmob, { getFormStrucSachkostenSkizzeEmob } from './SachkostenSkizzeLoewe';

// import schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
import { getVerbundPartnerName } from 'src/pages/private/online-antrag/application-helper-function/AppHelperfunctions';
const P = Schema.attributes;

export const GetSachkostenSkizzeLoewe = (application: any, hasCommentAusgabenUndFinanzierung?: boolean) => {
	const HinweisStruc = getKostenHinweisStruc(
		application,
		'Ausgabe',
		KOSTEN_ARTEN.Sachkosten,
		ANTRAG_TYP.Skizze,
		hasCommentAusgabenUndFinanzierung,
		true,
	);

	const OrgaStruc = [
		{
			label: get(application, P.Antragstellende_Organisa_0074063902_licher_Name_Der_Organisation.path, `Antragsteller`),
			content: (
				<SachkostenSkizzeEmob
					kostentraeger='Antragsteller'
					unternehmenId={get(getLocalstorageToken(), 'organisationId')}
					hasComment={hasCommentAusgabenUndFinanzierung}
				/>
			),
			formStruc: getFormStrucSachkostenSkizzeEmob(application, get(getLocalstorageToken(), 'organisationId')),
		},
	];
	const STRUC = get(application, P.Verbundpartner.path, []).map((_ele: any, i: number) => {
		return {
			label: getVerbundPartnerName(_ele, i),
			content: (
				<SachkostenSkizzeEmob
					kostentraeger='Verbundpartner'
					unternehmenId={get(_ele, 'Verbundpartner.id')}
					hasComment={hasCommentAusgabenUndFinanzierung}
				/>
			),
			formStruc: getFormStrucSachkostenSkizzeEmob(application, get(_ele, 'Verbundpartner.id')),
		};
	});

	return [...HinweisStruc, ...OrgaStruc, ...STRUC];
};
